<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" />
    <div class="case-product">
      <div class="case-product-content">
        <!-- <img v-lazy="imgserver+caseIdList.Img" alt /> -->
        <img v-lazy="getImageUrl(caseIdList.Img)" alt />
        <p class="product-title">{{caseIdList.Title}}</p>
        <p class="product-time">{{caseIdList.CreateTime}}</p>
        <p class="product-content">{{caseIdList.Content}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import builtInMock from '@/mock/home.json'
export default {
  components: {
    Banner
  },
  data() {
    return {
      pid: 0,
      caseIdList: {}
    };
  },
  created() {
    this.pid = this.$route.params.id;

  },
  mounted() {
    this.loadData();
  },
  methods: {
    getImageUrl(imgPath) {
      // Adjust the path according to your project structure
      return require(`@/assets/${imgPath}`); 
      // Or if images are in public folder:
      // return `/images/${imgPath}`;
    },
    async loadData() {
        const caseList = builtInMock.Cases || []
        const pidStr = String(this.pid)
        const found = caseList.find(item => String(item.Id) === pidStr)
        this.caseIdList=found;
    }
  }
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #14679f;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    //border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        height: 430px;
      }
      .product-title {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
      }
    }
  }
}
</style>